import { Usuario } from '../usuario';

export class UsuarioPopula {
    selected: boolean;
    exists: boolean;
    usuario: Usuario;

    constructor(usuario: Usuario) {
        this.usuario = usuario;
    }
}
